import template from "./client-list.html";
import controller from "./client-list.controller";
import "./client-list.scss";

const Component = {
    template,
    controller,
    controllerAs: "controller"
};

export default Component;


// WEBPACK FOOTER //
// ./sources/components/clients/client-list/client-list.component.js